import React from "react";

const DeleteAssignmentModal = ({
  studentName,
  setIsModalOpen,
  confirmDelete,
}) => {
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const styles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "8px",
      width: "300px",
      maxWidth: "90%",
    },
    modalHeader: {
      textAlign: "center",
      fontSize: "16px",
      marginBottom: "20px",
    },
    modalBody: {
      marginBottom: "20px",
    },
    modalFooter: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    dangerButton: {
      backgroundColor: "#FF4444",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
      width: "100%",
      cursor: "pointer",
      borderRadius: "4px",
    },
    cancelButton: {
      backgroundColor: "#EBEBEB",
      color: "#737373",
      border: "none",
      padding: "6px 12px",
      cursor: "pointer",
      width: "100%",
      borderRadius: "4px",
    },
  };

  return (
    <div style={styles.modalOverlay} onClick={closeModal}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>문제지 출제 취소</div>
        <div style={styles.modalBody}>
          <p style={{ textAlign: "center" }}>
            <strong>{studentName}</strong> 학생의 문제지를
          </p>
          <p style={{ textAlign: "center" }}>취소하시겠습니까?</p>
        </div>
        <div style={styles.modalFooter}>
          <button style={styles.dangerButton} onClick={confirmDelete}>
            네
          </button>
          <button style={styles.cancelButton} onClick={closeModal}>
            아니오
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAssignmentModal;
